import styled from 'styled-components';

export const Flex = styled.div`
	display: flex;
	flex-wrap: ${({ flexWrap }) => flexWrap || 'nowrap'};
	margin: ${({ margin }) => margin || 0};
`;

export const StyledTag = styled.div`
	padding: 0.5rem 1rem;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	color: ${({ theme }) => theme.colors.primary};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.3rem;
	margin: 1rem 0.5rem 0;
`;
